import { render } from "./HomeWidget.vue?vue&type=template&id=3d5f7afb"
import script from "./HomeWidget.vue?vue&type=script&lang=js"
export * from "./HomeWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__